import { Group } from '$synapse/models';
import { GroupService } from '$synapse/services';
import { Component, OnInit, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { GroupCreationDTO } from '$synapse/dtos';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SHARED_IMPORTS } from '../../../core/shared-imports';

@Component({
  selector: 'syn-group-creation-modal',
  templateUrl: './group-creation-modal.component.html',
  styleUrls: ['./group-creation-modal.component.scss'],
  imports: [SHARED_IMPORTS],
})
export class GroupCreationModalComponent implements OnInit {
  private readonly _data = inject<GroupCreationDTO>(MAT_DIALOG_DATA);
  private readonly _groupService = inject(GroupService);
  private readonly _modalDisplay =
    inject<MatDialogRef<GroupCreationModalComponent>>(MatDialogRef);

  group: GroupCreationDTO;
  send = false;

  ngOnInit(): void {
    this.group = new GroupCreationDTO();
  }

  submit(): void {
    this.send = true;
    this._createGroup().subscribe((group: Group) => {
      this._modalDisplay.close(group);
    });
  }

  private _createGroup(): Observable<Group> {
    return this._groupService.create(this.group);
  }
}
